/**
 * FIFA World Cup Sport Configuration
 */

import type { SportConfig } from './types';

export const soccerWorldCupConfig: SportConfig = {
  sport: 'SOCCER_WORLD_CUP',
  label: 'FIFA World Cup',
  shortLabel: 'World Cup',

  oddsApiSportKey: 'soccer_fifa_world_cup',

  drawLabel: 'Draw',
  espnPath: { sport: 'soccer', league: 'fifa.world' },

  positions: [
    { id: 'GK', label: 'Goalkeeper', abbreviation: 'GK' },
    { id: 'DEF', label: 'Defender', abbreviation: 'DEF' },
    { id: 'MID', label: 'Midfielder', abbreviation: 'MID' },
    { id: 'FWD', label: 'Forward', abbreviation: 'FWD' },
  ],

  propCategories: [
    { id: 'GOALS', label: 'Goals', oddsApiMarket: 'player_goals' },
    { id: 'ASSISTS', label: 'Assists', oddsApiMarket: 'player_assists' },
    { id: 'SHOTS_ON_TARGET', label: 'Shots on Target', oddsApiMarket: 'player_shots_on_target' },
  ],

  defaultRosterSlots: [
    { slot: 'GK', eligiblePositions: ['GK'], label: 'Goalkeeper' },
    { slot: 'DEF1', eligiblePositions: ['DEF'], label: 'Defender' },
    { slot: 'DEF2', eligiblePositions: ['DEF'], label: 'Defender' },
    { slot: 'MID1', eligiblePositions: ['MID'], label: 'Midfielder' },
    { slot: 'MID2', eligiblePositions: ['MID'], label: 'Midfielder' },
    { slot: 'FWD', eligiblePositions: ['FWD'], label: 'Forward' },
    { slot: 'UTIL', eligiblePositions: ['DEF', 'MID', 'FWD'], label: 'Utility' },
  ],

  defaultRosterSize: 7,
  defaultMaxProps: 5,

  identity: {
    color: '#326295',
    metal: 'Sapphire',
    icon: 'Globe',
  },

  teams: {},
};
